import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name zodiac-aries
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgNy41YTQuNSA0LjUgMCAxIDEgNSA0LjUiIC8+CiAgPHBhdGggZD0iTTcgMTJhNC41IDQuNSAwIDEgMSA1LTQuNVYyMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/zodiac-aries
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const ZodiacAries: IconNode = [
  ['path', { d: 'M12 7.5a4.5 4.5 0 1 1 5 4.5' }],
  ['path', { d: 'M7 12a4.5 4.5 0 1 1 5-4.5V21' }],
];

export default ZodiacAries;
